export default __webpack_public_path__ + "assets/camping-02e5e348.mp4";